
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { lambda_type, unit_type, int32_type, anonRecord_type, class_type, record_type, bool_type, list_type, option_type, float64_type, string_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ImageUpload, DnDFormImage, DnDFormImage_$reflection } from "../Image/ImageUploadDnD.js";
import { sortBy, toArray as toArray_1, length, reduce, exists, forAll, tryHead, contains, collect, choose, append as append_1, max, tryPick, tryFind, sumBy, filter, cons, find, singleton as singleton_1, empty, isEmpty, ofArray, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { FormState__getValidation, FormState__getFirstValidation, FormState__startLoading, ConsumableId__get_unwrap as ConsumableId__get_unwrap_1, StorageId, FormState__setValidationResponse_5219762A, ToolId__get_unwrap, FormState_get_empty, RequestedValue$1, TokenDataDto_$reflection, FormState_$reflection, RequestedValue$1_$reflection, ClientApiResponse$1_$reflection, ValidationResponseModule_affectsAnyOf } from "../../Shared/Shared.js";
import { Helper_receiverTypeNameTranslation, ReceiverTypeName, Receiver_$reflection } from "../../Shared/User.js";
import { FileUploadResponse_$reflection } from "../../Shared/File.js";
import { DataTransfer_DetailSet_$reflection } from "../../Shared/Set.js";
import { Helper_unitToTranslationKey, Consumable_$reflection } from "../../Shared/Consumable.js";
import { Helper_toolId, ToolTypes_$reflection } from "../../Shared/Tool.js";
import { Storage__get_DisplayName, Storage_$reflection } from "../../Shared/Storage.js";
import { MultiAssignToolWithQuantityItemDto, MultiAssignConsumableItemDto, MultiAssignSetItemDto, MultiAssignToolItemDto, AvailabilityRequestDto_$reflection, AvailabilityRequestDto, MultiAssignDto, MultiAssignDto_$reflection, AvailabilityResultDto_$reflection } from "../../Shared/MultiOperation.js";
import { BookingScope, Permission, Permissions_bookingScopeAtLeast, RolePermissionsDto_$reflection } from "../../Shared/Roles.js";
import { Cmd_none, Cmd_ofEffect, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { iterate, toArray, empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { getSelectedSets } from "../../Requests/Set.js";
import { Cmd_getSelectedConsumables } from "../../Requests/Consumable.js";
import { Cmd_getSelectedTools } from "../../Requests/Tool.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoderWithoutErrorPage, fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { addPrefix as addPrefix_1, fetchWithDecoder as fetchWithDecoder_1 } from "../../Communication.js";
import { ConsumableId__get_unwrap, SetId__get_unwrap, ToolId__get_unwrap as ToolId__get_unwrap_1 } from "../../Shared/Shared.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { toArray as toArray_2, unwrap, map as map_1, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Cmd_uploadImage } from "../../Requests/Files.js";
import { createObj, stringHash, safeHash, equals, comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { unwrapConsumableId, unwrapStorageId } from "../../Shared/Helper.js";
import { parse, newGuid } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { numberInputIntMaxValue, toISOString } from "../../Common.js";
import { DataTransferObject_CreateBulkAssignmentNotificationDto, DataTransferObject_CreateBulkAssignmentNotificationConsumableItem, DataTransferObject_CreateBulkAssignmentNotificationToolWithQuantityItem, DataTransferObject_CreateBulkAssignmentNotificationSetItem, DataTransferObject_CreateBulkAssignmentNotificationToolItem } from "../../Shared/AssignmentNotification.js";
import { createNotification } from "../../Requests/AssignmentNotification.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { TooltipAnchor } from "../../Components/TooltipAnchor.js";
import Shipment_Warning from "../../../public/assets/icons/Shipment_Warning.svg";
import { FSharpMap__get_IsEmpty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { ColumnDefinition$1, CellContent } from "../Table/Types.js";
import { InvalidTextValue } from "../../Components/Text.js";
import { NumberInput, Input } from "../../Components/Input.js";
import { GroupedSelect, Select } from "../../Components/Select.js";
import { TabsMenu } from "../TabsMenu.js";
import { TableControl$1, Table as Table_1 } from "../Table/Table.js";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import { List_groupBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { TextArea } from "../../Components/TextArea.js";
import { Checkbox } from "../../Components/Checkbox.js";
import { WarningAlert, InformationAlert } from "../../Components/Alert.js";
import { Button } from "../../Components/Button.js";
import { usePermissions } from "../../UserPermissions.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { whenOpen } from "../Helper.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { Skeleton } from "../../Components/Skeleton.js";

export class TableElementType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "ToolWithQuantity", "Consumable", "Set"];
    }
}

export function TableElementType_$reflection() {
    return union_type("Widgets.Modals.MultiAssignModal.TableElementType", [], TableElementType, () => [[], [], [], []]);
}

export class TableElement extends Record {
    constructor(Id, ElementId, AssignedReceiverName, Manufacturer, Model, Name, AdditionalName, InventoryNumber, QRCodeIds, Quanity, Type, Unit, Commission, SelectedStorageId, AvailableStorageIds, SenderImageFiles, ImageUploading) {
        super();
        this.Id = Id;
        this.ElementId = ElementId;
        this.AssignedReceiverName = AssignedReceiverName;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.Name = Name;
        this.AdditionalName = AdditionalName;
        this.InventoryNumber = InventoryNumber;
        this.QRCodeIds = QRCodeIds;
        this.Quanity = Quanity;
        this.Type = Type;
        this.Unit = Unit;
        this.Commission = Commission;
        this.SelectedStorageId = SelectedStorageId;
        this.AvailableStorageIds = AvailableStorageIds;
        this.SenderImageFiles = SenderImageFiles;
        this.ImageUploading = ImageUploading;
    }
}

export function TableElement_$reflection() {
    return record_type("Widgets.Modals.MultiAssignModal.TableElement", [], TableElement, () => [["Id", string_type], ["ElementId", string_type], ["AssignedReceiverName", string_type], ["Manufacturer", string_type], ["Model", string_type], ["Name", string_type], ["AdditionalName", string_type], ["InventoryNumber", string_type], ["QRCodeIds", string_type], ["Quanity", option_type(float64_type)], ["Type", TableElementType_$reflection()], ["Unit", string_type], ["Commission", string_type], ["SelectedStorageId", option_type(string_type)], ["AvailableStorageIds", list_type(string_type)], ["SenderImageFiles", list_type(DnDFormImage_$reflection())], ["ImageUploading", bool_type]]);
}

const maxSenderImages = 5;

function rowHintProperties(rowId) {
    return map((property) => concat(rowId, "-", ...property), ofArray(["tool-assigned-to-set", "not-in-active-state", "assigned-to-receiver", "hint"]));
}

function validationToastKey(tableElements, validationResponse) {
    if (ValidationResponseModule_affectsAnyOf(map((_arg) => _arg.Id, tableElements), validationResponse)) {
        return "validation.toast_rows";
    }
    else {
        return "validation.toast";
    }
}

function isReturnable(tableElement) {
    const matchValue = tableElement.Type;
    switch (matchValue.tag) {
        case 1:
        case 2:
            return false;
        default:
            return true;
    }
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Assign", "SetComment", "SetPlannedReturnDate", "SetCommission", "SetQuantity", "SetStorage", "SetSelectedReceiver", "SetWithNotification", "SetWithSignature", "AddElement", "RemoveElement", "SetSelectedSenderFiles", "SenderImageUploaded", "InitTableElements", "AssignedResponse", "SetsFetched", "ConsumableFetched", "ToolsFetched", "ReceiversFetched", "StoragesFetched", "AvailabilityFetched", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.Modals.MultiAssignModal.Msg", [], Msg, () => [[], [["Item", string_type]], [["Item", option_type(class_type("System.DateTime"))]], [["id", string_type], ["commission", string_type]], [["id", string_type], ["quantity", option_type(float64_type)]], [["id", string_type], ["storageId", option_type(string_type)]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", Receiver_$reflection()]))]], [["Item", bool_type]], [["Item", bool_type]], [["id", string_type]], [["id", string_type]], [["id", string_type], ["files", list_type(DnDFormImage_$reflection())]], [["id", string_type], ["response", FileUploadResponse_$reflection()]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", list_type(DataTransfer_DetailSet_$reflection())]], [["Item", list_type(Consumable_$reflection())]], [["Item", list_type(ToolTypes_$reflection())]], [["Item", list_type(Receiver_$reflection())]], [["Item", list_type(Storage_$reflection())]], [["Item", list_type(AvailabilityResultDto_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

export class PredefinedQuantityType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ConsumableQuantity", "ToolWithQuantity"];
    }
}

export function PredefinedQuantityType_$reflection() {
    return union_type("Widgets.Modals.MultiAssignModal.PredefinedQuantityType", [], PredefinedQuantityType, () => [[["Item", float64_type]], [["Item", int32_type]]]);
}

class State extends Record {
    constructor(SuccessCallback, OnClose, Receivers, Sets, Consumables, Storages, Tools, AvailabilityResult, TableElements, RemovedElements, Dto, PlannedReturnDate, FormState, UserData, Permissions, SenderId, ReceiverId, WithNotification, WithSignature, PredefinedQuantities) {
        super();
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Receivers = Receivers;
        this.Sets = Sets;
        this.Consumables = Consumables;
        this.Storages = Storages;
        this.Tools = Tools;
        this.AvailabilityResult = AvailabilityResult;
        this.TableElements = TableElements;
        this.RemovedElements = RemovedElements;
        this.Dto = Dto;
        this.PlannedReturnDate = PlannedReturnDate;
        this.FormState = FormState;
        this.UserData = UserData;
        this.Permissions = Permissions;
        this.SenderId = SenderId;
        this.ReceiverId = ReceiverId;
        this.WithNotification = WithNotification;
        this.WithSignature = WithSignature;
        this.PredefinedQuantities = PredefinedQuantities;
    }
}

function State_$reflection() {
    return record_type("Widgets.Modals.MultiAssignModal.State", [], State, () => [["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Receivers", RequestedValue$1_$reflection(list_type(Receiver_$reflection()))], ["Sets", RequestedValue$1_$reflection(list_type(DataTransfer_DetailSet_$reflection()))], ["Consumables", RequestedValue$1_$reflection(list_type(Consumable_$reflection()))], ["Storages", RequestedValue$1_$reflection(list_type(Storage_$reflection()))], ["Tools", RequestedValue$1_$reflection(list_type(ToolTypes_$reflection()))], ["AvailabilityResult", RequestedValue$1_$reflection(list_type(AvailabilityResultDto_$reflection()))], ["TableElements", list_type(TableElement_$reflection())], ["RemovedElements", list_type(TableElement_$reflection())], ["Dto", MultiAssignDto_$reflection()], ["PlannedReturnDate", option_type(class_type("System.DateTime"))], ["FormState", FormState_$reflection()], ["UserData", TokenDataDto_$reflection()], ["Permissions", RolePermissionsDto_$reflection()], ["SenderId", option_type(string_type)], ["ReceiverId", option_type(string_type)], ["WithNotification", bool_type], ["WithSignature", bool_type], ["PredefinedQuantities", list_type(anonRecord_type(["Id", string_type], ["PredefinedQuantityType", PredefinedQuantityType_$reflection()]))]]);
}

function init(successCallback, onClose, userData, permissions, senderId, assignProps, predefinedQuantities, receiverId) {
    return [new State(successCallback, onClose, new RequestedValue$1(0, []), isEmpty(assignProps.SetIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), isEmpty(assignProps.ConsumableIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), new RequestedValue$1(0, []), isEmpty(assignProps.ToolIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), new RequestedValue$1(0, []), empty(), empty(), new MultiAssignDto("", empty(), empty(), empty(), empty(), "", undefined, undefined), undefined, FormState_get_empty(), userData, permissions, senderId, receiverId, false, false, predefinedQuantities), Cmd_batch(toList(delay(() => append(!isEmpty(assignProps.SetIds) ? singleton(getSelectedSets(assignProps.SetIds, (Item) => (new Msg(15, [Item])), (Item_1) => (new Msg(21, [Item_1])))) : empty_1(), delay(() => append(!isEmpty(assignProps.ConsumableIds) ? singleton(Cmd_getSelectedConsumables(assignProps.ConsumableIds, (Item_2) => (new Msg(16, [Item_2])), (Item_3) => (new Msg(21, [Item_3])))) : empty_1(), delay(() => append(!isEmpty(assignProps.ToolIds) ? singleton(Cmd_getSelectedTools(map(ToolId__get_unwrap, assignProps.ToolIds), (Item_4) => (new Msg(17, [Item_4])), (Item_5) => (new Msg(21, [Item_5])))) : empty_1(), delay(() => {
        let businessUnitId;
        return append(singleton((businessUnitId = undefined, Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_2;
            return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Receiver_$reflection())));
            }, refreshOn)))(true).then((_arg) => {
                const result_1 = _arg;
                return (result_1.tag === 1) ? (Promise.resolve((() => {
                    throw new ValidationOnGetRequest(result_1.fields[0]);
                })())) : (Promise.resolve(result_1.fields[0]));
            });
        })), concat("/api/receivers/active", ...((businessUnitId == null) ? "?businessUnitId=" : concat("?businessUnitId=", ...businessUnitId))), (Item_6) => (new Msg(18, [Item_6])), (Item_7) => (new Msg(21, [Item_7]))))), delay(() => append(singleton(Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder_1(0, addPrefix_1(url_3), singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
            const pr_1 = response_2.arrayBuffer();
            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(Storage_$reflection())));
        })))), "/api/storages/access", (Item_8) => (new Msg(19, [Item_8])), (Item_9) => (new Msg(21, [Item_9])))), delay(() => {
            let dto;
            return singleton((dto = (new AvailabilityRequestDto(map(ToolId__get_unwrap_1, assignProps.ToolIds), map(SetId__get_unwrap, assignProps.SetIds), map(ConsumableId__get_unwrap, assignProps.ConsumableIds))), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoderWithoutErrorPage(addPrefix(tupledArg[0]), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response_3) => {
                const pr_2 = response_3.arrayBuffer();
                return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), list_type(AvailabilityResultDto_$reflection())));
            }).then((_arg_3) => {
                const result_4 = _arg_3;
                return (result_4.tag === 1) ? (Promise.resolve((() => {
                    throw new ValidationOnGetRequest(result_4.fields[0]);
                })())) : (Promise.resolve(result_4.fields[0]));
            })))), ["/api/multi-operations/availability", toString(0, Auto_generateBoxedEncoder_437914C6(AvailabilityRequestDto_$reflection(), undefined, undefined, undefined)(dto))], (Item_10) => (new Msg(20, [Item_10])), (Item_11) => (new Msg(21, [Item_11])))));
        }))));
    })))))))))];
}

function update(msg, state) {
    let bind$0040_1, bind$0040_2, file_4, elements;
    switch (msg.tag) {
        case 14: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                const validationResponse = response_2.fields[0];
                return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, FormState__setValidationResponse_5219762A(state.FormState, validationResponse), state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), Cmd_errorToast(validationToastKey(state.TableElements, validationResponse))];
            }
            else {
                return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, FormState_get_empty(), state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 5:
            return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, map((tableElement_1) => {
                if (tableElement_1.Id === msg.fields[0]) {
                    return new TableElement(tableElement_1.Id, tableElement_1.ElementId, tableElement_1.AssignedReceiverName, tableElement_1.Manufacturer, tableElement_1.Model, tableElement_1.Name, tableElement_1.AdditionalName, tableElement_1.InventoryNumber, tableElement_1.QRCodeIds, tableElement_1.Quanity, tableElement_1.Type, tableElement_1.Unit, tableElement_1.Commission, msg.fields[1], tableElement_1.AvailableStorageIds, tableElement_1.SenderImageFiles, tableElement_1.ImageUploading);
                }
                else {
                    return tableElement_1;
                }
            }, state.TableElements), state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), Cmd_none()];
        case 3:
            return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, map((tableElement_2) => {
                if (tableElement_2.Id === msg.fields[0]) {
                    return new TableElement(tableElement_2.Id, tableElement_2.ElementId, tableElement_2.AssignedReceiverName, tableElement_2.Manufacturer, tableElement_2.Model, tableElement_2.Name, tableElement_2.AdditionalName, tableElement_2.InventoryNumber, tableElement_2.QRCodeIds, tableElement_2.Quanity, tableElement_2.Type, tableElement_2.Unit, msg.fields[1], tableElement_2.SelectedStorageId, tableElement_2.AvailableStorageIds, tableElement_2.SenderImageFiles, tableElement_2.ImageUploading);
                }
                else {
                    return tableElement_2;
                }
            }, state.TableElements), state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), Cmd_none()];
        case 4:
            return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, map((tableElement_3) => {
                if (tableElement_3.Id === msg.fields[0]) {
                    return new TableElement(tableElement_3.Id, tableElement_3.ElementId, tableElement_3.AssignedReceiverName, tableElement_3.Manufacturer, tableElement_3.Model, tableElement_3.Name, tableElement_3.AdditionalName, tableElement_3.InventoryNumber, tableElement_3.QRCodeIds, msg.fields[1], tableElement_3.Type, tableElement_3.Unit, tableElement_3.Commission, tableElement_3.SelectedStorageId, tableElement_3.AvailableStorageIds, tableElement_3.SenderImageFiles, tableElement_3.ImageUploading);
                }
                else {
                    return tableElement_3;
                }
            }, state.TableElements), state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), Cmd_none()];
        case 1:
            return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, state.TableElements, state.RemovedElements, (bind$0040_1 = state.Dto, new MultiAssignDto(bind$0040_1.ReceiverId, bind$0040_1.Tools, bind$0040_1.Sets, bind$0040_1.Consumables, bind$0040_1.ToolsWithQuantity, msg.fields[0], bind$0040_1.SignatureUrl, bind$0040_1.PlannedReturnDate)), state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), Cmd_none()];
        case 2:
            return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, state.TableElements, state.RemovedElements, state.Dto, msg.fields[0], state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), Cmd_none()];
        case 6:
            return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, state.TableElements, state.RemovedElements, (bind$0040_2 = state.Dto, new MultiAssignDto(defaultArg(map_1((v) => v.value.Id, msg.fields[0]), ""), bind$0040_2.Tools, bind$0040_2.Sets, bind$0040_2.Consumables, bind$0040_2.ToolsWithQuantity, bind$0040_2.Comment, bind$0040_2.SignatureUrl, bind$0040_2.PlannedReturnDate)), state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), Cmd_none()];
        case 7: {
            const value_17 = msg.fields[0];
            if (!value_17) {
                return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, false, false, state.PredefinedQuantities), Cmd_none()];
            }
            else {
                return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, value_17, state.WithSignature, state.PredefinedQuantities), Cmd_none()];
            }
        }
        case 8: {
            const value_18 = msg.fields[0];
            if (value_18) {
                return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, true, value_18, state.PredefinedQuantities), Cmd_none()];
            }
            else {
                return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, value_18, state.PredefinedQuantities), Cmd_none()];
            }
        }
        case 9: {
            const id_3 = msg.fields[0];
            return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, cons(find((tableElement_4) => (tableElement_4.Id === id_3), state.RemovedElements), state.TableElements), filter((tableElement_5) => (tableElement_5.Id !== id_3), state.RemovedElements), state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), Cmd_none()];
        }
        case 10: {
            const id_4 = msg.fields[0];
            const selectedElement_1 = find((tableElement_6) => (tableElement_6.Id === id_4), state.TableElements);
            return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, filter((tableElement_7) => (tableElement_7.Id !== id_4), state.TableElements), cons(selectedElement_1, state.RemovedElements), state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), Cmd_none()];
        }
        case 11: {
            const newFiles = msg.fields[1];
            const id_5 = msg.fields[0];
            const alreadyUploadedCount = defaultArg(map_1((element_18) => (sumBy((file_1) => {
                if (file_1.tag === 0) {
                    return 0;
                }
                else {
                    return 1;
                }
            }, element_18.SenderImageFiles, {
                GetZero: () => 0,
                Add: (x_1, y) => ((x_1 + y) | 0),
            }) | 0), tryFind((tableElement_8) => (tableElement_8.Id === id_5), state.TableElements)), 0) | 0;
            const pickedFile = tryPick((file_2) => {
                if (file_2.tag === 1) {
                    return undefined;
                }
                else {
                    return file_2.fields[0].File;
                }
            }, newFiles);
            let matchResult, file_5;
            if (pickedFile != null) {
                if ((file_4 = pickedFile, alreadyUploadedCount < maxSenderImages)) {
                    matchResult = 0;
                    file_5 = pickedFile;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const formData = new FormData();
                    formData.append(file_5.name, file_5);
                    return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, map((tableElement_9) => {
                        if (tableElement_9.Id === id_5) {
                            return new TableElement(tableElement_9.Id, tableElement_9.ElementId, tableElement_9.AssignedReceiverName, tableElement_9.Manufacturer, tableElement_9.Model, tableElement_9.Name, tableElement_9.AdditionalName, tableElement_9.InventoryNumber, tableElement_9.QRCodeIds, tableElement_9.Quanity, tableElement_9.Type, tableElement_9.Unit, tableElement_9.Commission, tableElement_9.SelectedStorageId, tableElement_9.AvailableStorageIds, newFiles, true);
                        }
                        else {
                            return tableElement_9;
                        }
                    }, state.TableElements), state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), Cmd_uploadImage((response_3) => (new Msg(12, [id_5, response_3])), (Item_4) => (new Msg(21, [Item_4])), formData)];
                }
                default:
                    return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, map((tableElement_10) => {
                        if (tableElement_10.Id === id_5) {
                            return new TableElement(tableElement_10.Id, tableElement_10.ElementId, tableElement_10.AssignedReceiverName, tableElement_10.Manufacturer, tableElement_10.Model, tableElement_10.Name, tableElement_10.AdditionalName, tableElement_10.InventoryNumber, tableElement_10.QRCodeIds, tableElement_10.Quanity, tableElement_10.Type, tableElement_10.Unit, tableElement_10.Commission, tableElement_10.SelectedStorageId, tableElement_10.AvailableStorageIds, newFiles, tableElement_10.ImageUploading);
                        }
                        else {
                            return tableElement_10;
                        }
                    }, state.TableElements), state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), Cmd_none()];
            }
        }
        case 12: {
            const response_4 = msg.fields[1];
            const updateElement = (mapper) => map((tableElement_11) => {
                if (tableElement_11.Id === msg.fields[0]) {
                    return mapper(tableElement_11);
                }
                else {
                    return tableElement_11;
                }
            }, state.TableElements);
            switch (response_4.tag) {
                case 0:
                    return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, updateElement((tableElement_13) => (new TableElement(tableElement_13.Id, tableElement_13.ElementId, tableElement_13.AssignedReceiverName, tableElement_13.Manufacturer, tableElement_13.Model, tableElement_13.Name, tableElement_13.AdditionalName, tableElement_13.InventoryNumber, tableElement_13.QRCodeIds, tableElement_13.Quanity, tableElement_13.Type, tableElement_13.Unit, tableElement_13.Commission, tableElement_13.SelectedStorageId, tableElement_13.AvailableStorageIds, filter((file_8) => {
                        if (file_8.tag === 0) {
                            return false;
                        }
                        else {
                            return true;
                        }
                    }, tableElement_13.SenderImageFiles), false))), state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, updateElement((tableElement_14) => (new TableElement(tableElement_14.Id, tableElement_14.ElementId, tableElement_14.AssignedReceiverName, tableElement_14.Manufacturer, tableElement_14.Model, tableElement_14.Name, tableElement_14.AdditionalName, tableElement_14.InventoryNumber, tableElement_14.QRCodeIds, tableElement_14.Quanity, tableElement_14.Type, tableElement_14.Unit, tableElement_14.Commission, tableElement_14.SelectedStorageId, tableElement_14.AvailableStorageIds, filter((file_9) => {
                        if (file_9.tag === 0) {
                            return false;
                        }
                        else {
                            return true;
                        }
                    }, tableElement_14.SenderImageFiles), false))), state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), Cmd_errorToast("general.a_error_occured")];
                default:
                    return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, updateElement((tableElement_12) => {
                        const nextPosition = (1 + max(append_1(singleton_1(0), choose((file_6) => {
                            if (file_6.tag === 0) {
                                return undefined;
                            }
                            else {
                                return file_6.fields[0].Position;
                            }
                        }, tableElement_12.SenderImageFiles)), {
                            Compare: (x_2, y_1) => (comparePrimitives(x_2, y_1) | 0),
                        })) | 0;
                        return new TableElement(tableElement_12.Id, tableElement_12.ElementId, tableElement_12.AssignedReceiverName, tableElement_12.Manufacturer, tableElement_12.Model, tableElement_12.Name, tableElement_12.AdditionalName, tableElement_12.InventoryNumber, tableElement_12.QRCodeIds, tableElement_12.Quanity, tableElement_12.Type, tableElement_12.Unit, tableElement_12.Commission, tableElement_12.SelectedStorageId, tableElement_12.AvailableStorageIds, append_1(filter((file_7) => {
                            if (file_7.tag === 0) {
                                return false;
                            }
                            else {
                                return true;
                            }
                        }, tableElement_12.SenderImageFiles), singleton_1(new DnDFormImage(1, [{
                            ImageUrl: response_4.fields[0].ImageUrl,
                            Position: nextPosition,
                        }]))), false);
                    }), state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), Cmd_none()];
            }
        }
        case 18:
            return [new State(state.SuccessCallback, state.OnClose, new RequestedValue$1(1, [msg.fields[0]]), state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), singleton_1((dispatch) => {
                dispatch(new Msg(13, []));
            })];
        case 19:
            return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, new RequestedValue$1(1, [msg.fields[0]]), state.Tools, state.AvailabilityResult, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), singleton_1((dispatch_1) => {
                dispatch_1(new Msg(13, []));
            })];
        case 15:
            return [new State(state.SuccessCallback, state.OnClose, state.Receivers, new RequestedValue$1(1, [msg.fields[0]]), state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), singleton_1((dispatch_2) => {
                dispatch_2(new Msg(13, []));
            })];
        case 16:
            return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, new RequestedValue$1(1, [msg.fields[0]]), state.Storages, state.Tools, state.AvailabilityResult, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), singleton_1((dispatch_3) => {
                dispatch_3(new Msg(13, []));
            })];
        case 17:
            return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, new RequestedValue$1(1, [msg.fields[0]]), state.AvailabilityResult, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), singleton_1((dispatch_4) => {
                dispatch_4(new Msg(13, []));
            })];
        case 20:
            return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, new RequestedValue$1(1, [msg.fields[0]]), state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), singleton_1((dispatch_5) => {
                dispatch_5(new Msg(13, []));
            })];
        case 13: {
            const matchValue = state.Consumables;
            const matchValue_1 = state.Tools;
            const matchValue_2 = state.Sets;
            const matchValue_3 = state.Storages;
            const matchValue_4 = state.Receivers;
            let matchResult_1, consumables, receivers, sets, storages, tools;
            if (matchValue.tag === 0) {
                matchResult_1 = 1;
            }
            else if (matchValue_1.tag === 0) {
                matchResult_1 = 1;
            }
            else if (matchValue_2.tag === 0) {
                matchResult_1 = 1;
            }
            else if (matchValue_3.tag === 0) {
                matchResult_1 = 1;
            }
            else if (matchValue_4.tag === 0) {
                matchResult_1 = 1;
            }
            else if (state.AvailabilityResult.tag === 0) {
                matchResult_1 = 1;
            }
            else {
                matchResult_1 = 0;
                consumables = matchValue.fields[0];
                receivers = matchValue_4.fields[0];
                sets = matchValue_2.fields[0];
                storages = matchValue_3.fields[0];
                tools = matchValue_1.fields[0];
            }
            switch (matchResult_1) {
                case 0: {
                    const storageIds = map((storage) => storage.Id, storages);
                    const getStorageId = (storageId) => map_1((storage_2) => unwrapStorageId(storage_2.Id), tryFind((storage_1) => equals(storage_1.Id, storageId), storages));
                    const getReceiverName = (receiverId) => {
                        if (receiverId == null) {
                            return "";
                        }
                        else {
                            const receiverId_1 = receiverId;
                            return find((receiver) => (receiver.Id === receiverId_1), receivers).Name;
                        }
                    };
                    const setToolIds = map((tool) => tool.ToolId, collect((set$) => set$.AssignedTools, sets));
                    const setElements = map((set$_1) => (new TableElement(newGuid(), set$_1.Id, getReceiverName(set$_1.LocationInformation.AssignedReceiverId), set$_1.MasterData.Manufacturer, set$_1.MasterData.Model, set$_1.MasterData.Name, "", set$_1.MasterData.InventoryNumber, join(", ", map((_arg_2) => _arg_2.Value, filter((ai) => (ai.Kind === "qrCode"), set$_1.AssetIdentifiers))), undefined, new TableElementType(3, []), "piece", "", getStorageId(new StorageId(parse(set$_1.LocationInformation.StorageId))), empty(), empty(), false)), sets);
                    const toolElements = map((tool_2) => {
                        if (tool_2.tag === 1) {
                            const tool_4 = tool_2.fields[0];
                            const availableStorageIds = map((sps_1) => unwrapStorageId(sps_1.StorageId), filter((sps) => contains(sps.StorageId, storageIds, {
                                Equals: equals,
                                GetHashCode: (x_5) => (safeHash(x_5) | 0),
                            }), tool_4.StockPerStorage));
                            const quantity = defaultArg(map_1((predefinedQuantity_1) => {
                                const matchValue_7 = predefinedQuantity_1.PredefinedQuantityType;
                                if (matchValue_7.tag === 1) {
                                    return matchValue_7.fields[0] | 0;
                                }
                                else {
                                    return 0;
                                }
                            }, tryFind((predefinedQuantity) => (predefinedQuantity.Id === ToolId__get_unwrap(tool_4.Id)), state.PredefinedQuantities)), 0);
                            let receiverName;
                            const matchValue_8 = state.SenderId;
                            if (matchValue_8 != null) {
                                const senderId = matchValue_8;
                                receiverName = find((receiver_2) => (receiver_2.Id === senderId), receivers).Name;
                            }
                            else {
                                receiverName = "";
                            }
                            return new TableElement(newGuid(), ToolId__get_unwrap(tool_4.Id), receiverName, tool_4.Manufacturer, tool_4.Model, tool_4.DisplayName, "", tool_4.InventoryNumber, join(", ", collect((_arg_4) => _arg_4.QRCodeIds, tool_4.StockPerStorage)), quantity, new TableElementType(1, []), "piece", "", tryHead(availableStorageIds), availableStorageIds, empty(), false);
                        }
                        else {
                            const tool_3 = tool_2.fields[0];
                            return new TableElement(newGuid(), ToolId__get_unwrap(tool_3.Id), getReceiverName(tool_3.AssignedUserId), tool_3.Manufacturer, tool_3.Model, tool_3.DisplayName, "", tool_3.InventoryNumber, join(", ", tool_3.QRCodeIds), undefined, new TableElementType(0, []), "piece", "", getStorageId(tool_3.StorageId), empty(), empty(), false);
                        }
                    }, filter((tool_1) => !contains(ToolId__get_unwrap(Helper_toolId(tool_1)), setToolIds, {
                        Equals: (x_4, y_3) => (x_4 === y_3),
                        GetHashCode: (x_4) => (stringHash(x_4) | 0),
                    }), tools));
                    const consumableElements = map((consumable) => {
                        const availableStorageIds_1 = map((sps_3) => unwrapStorageId(sps_3.StorageId), filter((sps_2) => contains(sps_2.StorageId, storageIds, {
                            Equals: equals,
                            GetHashCode: (x_6) => (safeHash(x_6) | 0),
                        }), consumable.StockPerStorage));
                        const quantity_1 = defaultArg(map_1((predefinedQuantity_3) => {
                            const matchValue_9 = predefinedQuantity_3.PredefinedQuantityType;
                            if (matchValue_9.tag === 1) {
                                return 0;
                            }
                            else {
                                return matchValue_9.fields[0];
                            }
                        }, tryFind((predefinedQuantity_2) => (predefinedQuantity_2.Id === ConsumableId__get_unwrap_1(consumable.Id)), state.PredefinedQuantities)), 0);
                        return new TableElement(newGuid(), unwrapConsumableId(consumable.Id), "", "", "", consumable.Name, consumable.AdditionalName, consumable.InventoryNumber, join(", ", collect((_arg_5) => _arg_5.QRCodeIds, consumable.StockPerStorage)), quantity_1, new TableElementType(2, []), consumable.Unit, "", tryHead(availableStorageIds_1), availableStorageIds_1, empty(), false);
                    }, consumables);
                    let patternInput;
                    const allReceivers = () => {
                        const matchValue_10 = state.ReceiverId;
                        if (matchValue_10 != null) {
                            const receiverId_2 = matchValue_10;
                            const receiver_4 = find((response_11) => (response_11.Id === receiverId_2), receivers);
                            return [singleton_1(receiver_4), {
                                label: receiver_4.Name,
                                value: receiver_4,
                            }];
                        }
                        else {
                            return [receivers, undefined];
                        }
                    };
                    if (Permissions_bookingScopeAtLeast(state.Permissions, new Permission(6, []), new BookingScope(2, []))) {
                        patternInput = allReceivers();
                    }
                    else if ((elements = append_1(setElements, append_1(toolElements, consumableElements)), !isEmpty(elements) && forAll((element_19) => {
                        const matchValue_12 = element_19.SelectedStorageId;
                        if (matchValue_12 == null) {
                            return false;
                        }
                        else {
                            const storageId_1 = matchValue_12;
                            return defaultArg(map_1((storage_4) => contains(state.UserData.UserId, storage_4.AssignedUserIds, {
                                Equals: (x_7, y_6) => (x_7 === y_6),
                                GetHashCode: (x_7) => (stringHash(x_7) | 0),
                            }), tryFind((storage_3) => (unwrapStorageId(storage_3.Id) === storageId_1), storages)), false);
                        }
                    }, elements))) {
                        patternInput = allReceivers();
                    }
                    else {
                        const matchValue_11 = tryFind((response_12) => (response_12.Id === state.UserData.UserId), receivers);
                        if (matchValue_11 == null) {
                            patternInput = [empty(), undefined];
                        }
                        else {
                            const receiver_5 = matchValue_11;
                            patternInput = [singleton_1(receiver_5), {
                                label: receiver_5.Name,
                                value: receiver_5,
                            }];
                        }
                    }
                    return [new State(state.SuccessCallback, state.OnClose, new RequestedValue$1(1, [patternInput[0]]), state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, append_1(setElements, append_1(toolElements, consumableElements)), state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), singleton_1((dispatch_6) => {
                        dispatch_6(new Msg(6, [patternInput[1]]));
                    })];
                }
                default:
                    return [state, Cmd_none()];
            }
        }
        case 21:
            return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, map((tableElement_15) => (new TableElement(tableElement_15.Id, tableElement_15.ElementId, tableElement_15.AssignedReceiverName, tableElement_15.Manufacturer, tableElement_15.Model, tableElement_15.Name, tableElement_15.AdditionalName, tableElement_15.InventoryNumber, tableElement_15.QRCodeIds, tableElement_15.Quanity, tableElement_15.Type, tableElement_15.Unit, tableElement_15.Commission, tableElement_15.SelectedStorageId, tableElement_15.AvailableStorageIds, tableElement_15.SenderImageFiles, false)), state.TableElements), state.RemovedElements, state.Dto, state.PlannedReturnDate, FormState_get_empty(), state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), Cmd_errorToast("general.a_error_occured")];
        default: {
            const senderImageUrls = (element) => choose((file) => {
                if (file.tag === 0) {
                    return undefined;
                }
                else {
                    return file.fields[0].ImageUrl;
                }
            }, element.SenderImageFiles);
            const plannedReturnDate = exists(isReturnable, state.TableElements) ? map_1(toISOString, state.PlannedReturnDate) : undefined;
            let updatedDto;
            const bind$0040 = state.Dto;
            updatedDto = (new MultiAssignDto(bind$0040.ReceiverId, map((element_2) => (new MultiAssignToolItemDto(element_2.Id, element_2.ElementId, senderImageUrls(element_2))), filter((element_1) => equals(element_1.Type, new TableElementType(0, [])), state.TableElements)), map((element_4) => (new MultiAssignSetItemDto(element_4.Id, element_4.ElementId, senderImageUrls(element_4))), filter((element_3) => equals(element_3.Type, new TableElementType(3, [])), state.TableElements)), map((element_6) => (new MultiAssignConsumableItemDto(element_6.Id, element_6.ElementId, defaultArg(element_6.Quanity, 0), defaultArg(element_6.SelectedStorageId, ""), element_6.Commission, senderImageUrls(element_6))), filter((element_5) => equals(element_5.Type, new TableElementType(2, [])), state.TableElements)), map((element_8) => (new MultiAssignToolWithQuantityItemDto(element_8.Id, element_8.ElementId, defaultArg(map_1((value_2) => (~~value_2 | 0), element_8.Quanity), 0), defaultArg(element_8.SelectedStorageId, ""), state.SenderId, senderImageUrls(element_8))), filter((element_7) => equals(element_7.Type, new TableElementType(1, [])), state.TableElements)), bind$0040.Comment, bind$0040.SignatureUrl, plannedReturnDate));
            if (state.WithNotification) {
                const notificationDto = new DataTransferObject_CreateBulkAssignmentNotificationDto(state.Dto.ReceiverId, state.Dto.Comment, state.WithSignature, plannedReturnDate, map((element_10) => (new DataTransferObject_CreateBulkAssignmentNotificationToolItem(element_10.Id, element_10.ElementId, senderImageUrls(element_10))), filter((element_9) => equals(element_9.Type, new TableElementType(0, [])), state.TableElements)), map((element_12) => (new DataTransferObject_CreateBulkAssignmentNotificationSetItem(element_12.Id, element_12.ElementId, senderImageUrls(element_12))), filter((element_11) => equals(element_11.Type, new TableElementType(3, [])), state.TableElements)), map((element_14) => (new DataTransferObject_CreateBulkAssignmentNotificationToolWithQuantityItem(element_14.Id, element_14.ElementId, defaultArg(map_1((value_5) => (~~value_5 | 0), element_14.Quanity), 0), defaultArg(element_14.SelectedStorageId, ""), senderImageUrls(element_14))), filter((element_13) => equals(element_13.Type, new TableElementType(1, [])), state.TableElements)), map((element_16) => (new DataTransferObject_CreateBulkAssignmentNotificationConsumableItem(element_16.Id, element_16.ElementId, defaultArg(element_16.Quanity, 0), defaultArg(element_16.SelectedStorageId, ""), element_16.Commission, senderImageUrls(element_16))), filter((element_15) => equals(element_15.Type, new TableElementType(2, [])), state.TableElements)));
                return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, FormState__startLoading(state.FormState), state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), createNotification(notificationDto, (Item) => (new Msg(14, [Item])), (Item_1) => (new Msg(21, [Item_1])))];
            }
            else {
                return [new State(state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.AvailabilityResult, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, FormState__startLoading(state.FormState), state.UserData, state.Permissions, state.SenderId, state.ReceiverId, state.WithNotification, state.WithSignature, state.PredefinedQuantities), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_2;
                    return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                        const pr = response.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                    }, refreshOn)))(true);
                })), ["/api/multi-operations/assign", toString(0, Auto_generateBoxedEncoder_437914C6(MultiAssignDto_$reflection(), undefined, undefined, undefined)(updatedDto))], (Item_2) => (new Msg(14, [Item_2])), (Item_3) => (new Msg(21, [Item_3])))];
            }
        }
    }
}

function hasInspectionWarning(dto) {
    const matchValue = dto.InspectionStatus;
    let matchResult;
    if (matchValue != null) {
        switch (matchValue) {
            case "expired":
            case "failed":
            case "neverInspected": {
                matchResult = 0;
                break;
            }
            default:
                matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return true;
        default:
            return false;
    }
}

function AvailabilityResultComponent(props) {
    let matchValue, Child, elems_1, elems, Tooltip, elems_3;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const storageNames = isEmpty(props.Dto.StorageNames) ? "" : reduce((s1, s2) => concat(s1, ", ", ...s2), props.Dto.StorageNames);
    const allWarnings = append_1(map((blocker) => {
        let arg_1;
        switch (blocker) {
            case "problemReportExists":
                return reactElement("li", {
                    children: t("multi_operation.warning.problem_report_exists"),
                });
            case "reservationExists":
                return reactElement("li", {
                    children: (arg_1 = {
                        storages: storageNames,
                    }, patternInput[1].t("multi_operation.warning.reservation_exists", arg_1)),
                });
            default:
                return reactElement("li", {
                    children: t("multi_operation.warning.appointment_exists"),
                });
        }
    }, props.Dto.Blockers), (matchValue = props.Dto.InspectionStatus, (matchValue != null) ? ((matchValue === "expired") ? singleton_1(reactElement("li", {
        children: t("multi_operation.warning.inspection_expired"),
    })) : ((matchValue === "failed") ? singleton_1(reactElement("li", {
        children: t("multi_operation.warning.inspection_failed"),
    })) : ((matchValue === "neverInspected") ? singleton_1(reactElement("li", {
        children: t("multi_operation.warning.inspection_never_inspected"),
    })) : empty()))) : empty()));
    return createElement(TooltipAnchor, (Child = reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["text-red", "h-5", "w-5"])], (elems = [Shipment_Warning()], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (Tooltip = reactElement("div", createObj(ofArray([["className", "bg-[#FEFCE8] text-base pl-8 p-4 rounded"], (elems_3 = [reactElement("ul", {
        className: join(" ", ["list-disc", "space-y-2"]),
        children: reactApi.Children.toArray(Array.from(allWarnings)),
    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), {
        Child: Child,
        TestId: concat("tooltip-test-id-", ...props.Dto.Id),
        Tooltip: Tooltip,
    })));
}

function Table(props) {
    let elems_1;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const i18n = patternInput[1];
    const containsConsumables = exists((tableElement) => equals(tableElement.Type, new TableElementType(2, [])), props.TableElements);
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const columnDefinition = toArray(delay(() => append(!FSharpMap__get_IsEmpty(props.FormState.Validations) ? singleton(new ColumnDefinition$1("hint", "", t("assign_multiple_tools_dialog.hint"), (row) => {
        const matchValue = FormState__getFirstValidation(props.FormState, t, rowHintProperties(row.Id));
        if (matchValue == null) {
            return new CellContent(0, [""]);
        }
        else {
            const value = matchValue;
            return new CellContent(2, [createElement(InvalidTextValue, {
                TestId: concat(row.Id, ..."-validation-message"),
                Text: value,
            })]);
        }
    }, "none", "text")) : empty_1(), delay(() => append(!isEmpty(props.AvailabilityResults) ? singleton(new ColumnDefinition$1("available-information", "", "", (row_1) => {
        const availabilityResult_1 = tryFind((availabilityResult) => (availabilityResult.Id === row_1.ElementId), props.AvailabilityResults);
        if (availabilityResult_1 == null) {
            return new CellContent(0, [""]);
        }
        else {
            const availabilityResult_2 = availabilityResult_1;
            return (!availabilityResult_2.Available ? true : hasInspectionWarning(availabilityResult_2)) ? (new CellContent(2, [createElement(AvailabilityResultComponent, {
                Dto: availabilityResult_2,
            })])) : (new CellContent(0, [""]));
        }
    }, "none", "text")) : empty_1(), delay(() => append(singleton(new ColumnDefinition$1("manufacturer", "", t("assign_multiple_tools_dialog.manufacturer"), (row_2) => (new CellContent(0, [row_2.Manufacturer])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("model", "", t("assign_multiple_tools_dialog.model"), (row_3) => (new CellContent(0, [row_3.Model])), "none", "text")), delay(() => append(containsConsumables ? singleton(new ColumnDefinition$1("additionalName", "", t("consumable.additional_name"), (row_4) => (new CellContent(0, [row_4.AdditionalName])), "none", "text")) : empty_1(), delay(() => append(singleton(new ColumnDefinition$1("name", "", t("tool.displayname"), (row_5) => (new CellContent(0, [row_5.Name])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("assignedReceiverName", "", t("dashboard.assigned_to"), (row_6) => (new CellContent(0, [row_6.AssignedReceiverName])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("inventoryNumber", "", t("assign_multiple_tools_dialog.inventory_number"), (row_7) => (new CellContent(0, [row_7.InventoryNumber])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("qrCodeIds", "", t("general.qr_code"), (row_8) => (new CellContent(0, [row_8.QRCodeIds])), "none", "text")), delay(() => append(containsConsumables ? singleton(new ColumnDefinition$1("commission", "", t("general.commission"), (row_9) => {
        const matchValue_1 = row_9.Type;
        switch (matchValue_1.tag) {
            case 0:
            case 1:
            case 3:
                return new CellContent(0, [""]);
            default:
                return new CellContent(2, [createElement(Input, {
                    ComponentState: componentState,
                    OnChange: (value_1) => {
                        props.Dispatch(new Msg(3, [row_9.Id, value_1]));
                    },
                    TestId: concat("multi-assign-", row_9.Id, ..."-commission-input"),
                    Value: row_9.Commission,
                })]);
        }
    }, "none", "text")) : empty_1(), delay(() => append(singleton(new ColumnDefinition$1("quantity", "", t("general.quantity_3"), (row_10) => {
        let Value_2, ValidationMessage_2, Value_1, ValidationMessage_1;
        const matchValue_2 = row_10.Type;
        switch (matchValue_2.tag) {
            case 1:
                return new CellContent(2, [createElement(NumberInput, (Value_2 = map_1((value_4) => value_4, row_10.Quanity), (ValidationMessage_2 = FormState__getValidation(props.FormState, t, concat(row_10.Id, ..."-quantity")), {
                    ComponentState: componentState,
                    MaxValue: numberInputIntMaxValue,
                    OnChange: (value_5) => {
                        props.Dispatch(new Msg(4, [row_10.Id, value_5]));
                    },
                    TestId: concat("multi-assign-", row_10.Id, ..."-quantity-input"),
                    ValidationMessage: unwrap(ValidationMessage_2),
                    Value: unwrap(Value_2),
                })))]);
            case 0:
            case 3:
                return new CellContent(0, ["1"]);
            default:
                return new CellContent(2, [createElement(NumberInput, (Value_1 = map_1((value_2) => value_2, row_10.Quanity), (ValidationMessage_1 = FormState__getValidation(props.FormState, t, concat(row_10.Id, ..."-quantity")), {
                    ComponentState: componentState,
                    OnChange: (value_3) => {
                        props.Dispatch(new Msg(4, [row_10.Id, value_3]));
                    },
                    TestId: concat("multi-assign-", row_10.Id, ..."-quantity-input"),
                    ValidationMessage: unwrap(ValidationMessage_1),
                    Value: unwrap(Value_1),
                })))]);
        }
    }, "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("unit", "", t("general.unit"), (row_11) => (new CellContent(0, [t(Helper_unitToTranslationKey(row_11.Unit))])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("storage", "", t("general.storage"), (row_12) => {
        let ValidationMessage_3;
        let selectedStorage;
        const matchValue_3 = row_12.SelectedStorageId;
        if (matchValue_3 == null) {
            selectedStorage = undefined;
        }
        else {
            const storageId = matchValue_3;
            selectedStorage = map_1((storage_1) => ({
                label: Storage__get_DisplayName(storage_1),
                value: storage_1,
            }), tryFind((storage) => equals(storage.Id, new StorageId(parse(storageId))), props.Storages));
        }
        const options = map((storage_3) => ({
            label: Storage__get_DisplayName(storage_3),
            value: storage_3,
        }), filter((storage_2) => contains(unwrapStorageId(storage_2.Id), row_12.AvailableStorageIds, {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        }), props.Storages));
        return new CellContent(2, [createElement(Select, (ValidationMessage_3 = FormState__getValidation(props.FormState, t, concat(row_12.Id, ..."-storage")), {
            ComponentState: componentState,
            IsClearable: false,
            NoOptionsMessage: "select.storage_no_options",
            OnChange: (value_7) => {
                props.Dispatch(new Msg(5, [row_12.Id, map_1((value_8) => unwrapStorageId(value_8.value.Id), value_7)]));
            },
            Options: options,
            PlaceholderKey: "select.storage_placeholder",
            TestId: concat("multi-assign-", row_12.Id, ..."-storage-select"),
            ValidationMessage: unwrap(ValidationMessage_3),
            Value: unwrap(selectedStorage),
        }))]);
    }, "none", "text")), delay(() => singleton(new ColumnDefinition$1("senderImages", "", t("assignment_notification.sender_images"), (row_13) => (new CellContent(2, [createElement(ImageUpload, {
        ComponentState: row_13.ImageUploading ? "disabled" : componentState,
        SelectedFiles: row_13.SenderImageFiles,
        SetSelectedFile: (files) => {
            props.Dispatch(new Msg(11, [row_13.Id, files]));
        },
    })])), "none", "text"))))))))))))))))))))))))))))));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_1 = toList(delay(() => {
        let elems, arg_1, arg_3;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4", "mb-4"])], (elems = [createElement(TabsMenu, {
            Tabs: ofArray([{
                IsSelected: props.IsAddedElementTabVisible,
                Label: containsConsumables ? t("assign_multiple_tools_dialog.consumables") : t("assign_multiple_tools_dialog.tools"),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(true);
                },
                TestId: "multi-modal-tab-elements",
            }, {
                IsSelected: !props.IsAddedElementTabVisible,
                Label: containsConsumables ? ((arg_1 = {
                    numberOfRemovedTools: length(props.RemovedElements),
                }, i18n.t("assign_multiple_tools_dialog.removed_consumables_elements", arg_1))) : ((arg_3 = {
                    numberOfRemovedTools: length(props.RemovedElements),
                }, i18n.t("assign_multiple_tools_dialog.removed_elements", arg_3))),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(false);
                },
                TestId: "multi-modal-tab-removed-elements",
            }]),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let TableRows, Options, TableRows_1, Options_1;
            return props.IsAddedElementTabVisible ? singleton(createElement(Table_1, (TableRows = toArray_1(props.TableElements), (Options = {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["manufacturer", "asc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "singleRow",
                SaveTableConfiguration: false,
            }, {
                ColumnDefinitions: columnDefinition,
                Controls: singleton_1(new TableControl$1(t("general.remove"), Recycle_Bin_1(), props.FormState.IsLoading ? undefined : ((rows) => {
                    iterate((row_15) => {
                        props.Dispatch(new Msg(10, [row_15]));
                    }, toArray_2(map_1((row_14) => row_14.Id, tryHead(rows))));
                }), true, false, "tools-dialog-toolreservation-dialog-remove-button")),
                Options: Options,
                TableKey: "not-defined-table",
                TableRows: TableRows,
            })))) : singleton(createElement(Table_1, (TableRows_1 = toArray_1(props.RemovedElements), (Options_1 = {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["manufacturer", "asc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "singleRow",
                SaveTableConfiguration: false,
            }, {
                ColumnDefinitions: columnDefinition,
                Controls: singleton_1(new TableControl$1(t("general.remove"), Recycle_Bin_1(), props.FormState.IsLoading ? undefined : ((rows_1) => {
                    iterate((row_17) => {
                        props.Dispatch(new Msg(9, [row_17]));
                    }, toArray_2(map_1((row_16) => row_16.Id, tryHead(rows_1))));
                }), true, false, "tools-dialog-toolreservation-dialog-remove-button")),
                Options: Options_1,
                TableKey: "not-defined-table",
                TableRows: TableRows_1,
            }))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function Form(props) {
    let elems_2;
    const t = useTranslation()[0];
    const isNotifiableReceiver = (receiver) => {
        if (receiver.ReceiverType.tag === 0) {
            return true;
        }
        else {
            return receiver.Email != null;
        }
    };
    const notifiableReceivers = props.WithNotification ? filter(isNotifiableReceiver, props.Receivers) : props.Receivers;
    const selectedReceiverIsNotifiable = defaultArg(map_1(isNotifiableReceiver, tryFind((receiver_1) => (receiver_1.Id === props.Dto.ReceiverId), props.Receivers)), false);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4", "mt-4", "w-96"])], (elems_2 = toList(delay(() => append(singleton(createElement(GroupedSelect, (($value) => { $value.key = $value.Key; return $value; })({
        ComponentState: props.FormState,
        IsClearable: false,
        Key: "select-user",
        Label: t("general.user"),
        NoOptionsMessage: "select.employee_no_options",
        OnChange: (value_2) => {
            props.Dispatch(new Msg(6, [value_2]));
        },
        Options: map((tupledArg) => {
            const receiverType = tupledArg[0];
            const receivers_1 = toArray_1(sortBy((receiver_4) => receiver_4.label.toLowerCase(), map((receiver_3) => {
                const matchValue_1 = receiver_3.LocationName;
                if (matchValue_1 != null) {
                    const locationName = matchValue_1;
                    if (equals(receiverType, new ReceiverTypeName(4, []))) {
                        return {
                            label: concat(locationName, " - ", ...receiver_3.Name),
                            value: receiver_3,
                        };
                    }
                    else {
                        return {
                            label: concat(receiver_3.Name, " - ", ...locationName),
                            value: receiver_3,
                        };
                    }
                }
                else {
                    return {
                        label: receiver_3.Name,
                        value: receiver_3,
                    };
                }
            }, tupledArg[1]), {
                Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
            }));
            return {
                label: Helper_receiverTypeNameTranslation(t, receiverType),
                options: receivers_1,
            };
        }, List_groupBy((receiver_2) => receiver_2.ReceiverType, notifiableReceivers, {
            Equals: equals,
            GetHashCode: (x) => (safeHash(x) | 0),
        })),
        PlaceholderKey: "select.employee_placeholder",
        Value: unwrap(map_1((receiver_6) => ({
            label: receiver_6.Name,
            value: receiver_6,
        }), tryFind((receiver_5) => (receiver_5.Id === props.Dto.ReceiverId), notifiableReceivers))),
    }))), delay(() => {
        let elems;
        return append(props.HasReturnableElements ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1.5"])], (elems = toList(delay(() => append(singleton(createElement(DatePicker, {
            ComponentState: props.FormState,
            IsClearable: true,
            Label: t("tool.dialog_planned_return_date"),
            OnChange: (value_4) => {
                props.Dispatch(new Msg(2, [value_4]));
            },
            TestId: "change-return-date-test-id",
            ValidationMessage: unwrap(FormState__getValidation(props.ValidationFormState, t, "plannedReturnDate")),
            Value: unwrap(props.PlannedReturnDate),
        })), delay(() => (props.HasNonReturnableElements ? singleton(reactElement("div", {
            className: join(" ", ["text-xs", "text-text-muted"]),
            children: t("multi_operation.assign.planned_return_date_hint"),
            "data-test-id": "multi-assign-planned-return-date-hint",
        })) : empty_1()))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty_1(), delay(() => append(singleton(createElement(TextArea, {
            ComponentState: props.FormState,
            Label: t("general.comment"),
            OnChange: (value_11) => {
                props.Dispatch(new Msg(1, [value_11]));
            },
            TestId: "multi-assign-comment-test-id",
            Value: props.Dto.Comment,
        })), delay(() => append(singleton(Checkbox({
            ComponentState: props.FormState,
            IsChecked: props.WithNotification,
            Label: t("tool.dialog_assign_with_notification"),
            OnCheck: (value_12) => {
                props.Dispatch(new Msg(7, [value_12]));
            },
            TestId: "multi-assign-with-notification-test-id",
        })), delay(() => append(props.WithNotification ? singleton(createElement(InformationAlert, {
            Label: t("tool.dialog_assign_with_notification_info"),
        })) : empty_1(), delay(() => append(singleton(Checkbox({
            ComponentState: props.FormState,
            IsChecked: props.WithSignature,
            Label: t("tool.dialog_assign_with_signature"),
            OnCheck: (value_13) => {
                props.Dispatch(new Msg(8, [value_13]));
            },
            TestId: "multi-assign-with-signature-test-id",
        })), delay(() => {
            let elems_1, Label_5;
            return singleton(reactElement("div", createObj(singleton_1((elems_1 = [createElement(Button, (Label_5 = t("general.save"), {
                ComponentState: (props.FormState === "disabled") ? "disabled" : ((((((props.Dto.ReceiverId === "") ? true : props.IsTableElementsEmpty) ? true : props.HasTableElementEmptyStorageId) ? true : props.HasUploadingImages) ? true : (props.WithNotification && !selectedReceiverIsNotifiable)) ? "disabled" : "enabled"),
                Label: Label_5,
                OnClick: () => {
                    props.Dispatch(new Msg(0, []));
                },
                TestId: "tools-dialog-toolreservation-save-button",
                Variant: "primary",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])))));
        }))))))))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function Content(props) {
    let elems_3, elems_2;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(true);
    const isAddedElementsTabSelected = patternInput_1[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const containsOnlyConsumables = isEmpty(filter((tableElement) => {
        const matchValue = tableElement.Type;
        switch (matchValue.tag) {
            case 2:
                return false;
            default:
                return true;
        }
    }, props.TableElements));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["min-h-48"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["p-4"])], (elems_2 = toList(delay(() => {
        let elems_1;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = toList(delay(() => {
            let elems;
            return append(isEmpty(props.Storages) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-5"])], (elems = [createElement(WarningAlert, {
                Label: t("multi_operation.assign.no_storage_access"),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty_1(), delay(() => append(!containsOnlyConsumables ? singleton(createElement(InformationAlert, {
                Label: t("multi_operation.assign.information"),
            })) : empty_1(), delay(() => singleton(createElement(Table, {
                AvailabilityResults: props.AvailabilityResults,
                Dispatch: props.Dispatch,
                FormState: props.FormState,
                IsAddedElementTabVisible: isAddedElementsTabSelected,
                RemovedElements: props.RemovedElements,
                SetIsAddedElementTabVisible: patternInput_1[1],
                Storages: props.Storages,
                TableElements: props.TableElements,
            }))))));
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let HasReturnableElements, IsTableElementsEmpty;
            return isAddedElementsTabSelected ? singleton(createElement(Form, (HasReturnableElements = exists(isReturnable, props.TableElements), (IsTableElementsEmpty = isEmpty(props.TableElements), {
                Dispatch: props.Dispatch,
                Dto: props.Dto,
                FormState: componentState,
                HasNonReturnableElements: exists((tableElement_2) => !isReturnable(tableElement_2), props.TableElements),
                HasReturnableElements: HasReturnableElements,
                HasTableElementEmptyStorageId: exists((tableElement_3) => (tableElement_3.SelectedStorageId == null), props.TableElements),
                HasUploadingImages: exists((tableElement_4) => tableElement_4.ImageUploading, props.TableElements),
                IsTableElementsEmpty: IsTableElementsEmpty,
                PlannedReturnDate: unwrap(props.PlannedReturnDate),
                Receivers: props.Receivers,
                ValidationFormState: props.FormState,
                WithNotification: props.WithNotification,
                WithSignature: props.WithSignature,
            })))) : empty_1();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function MultiAssignModalSheet(props) {
    let elems, matchValue, matchValue_1, matchValue_2, matchValue_3, matchValue_4, matchValue_5;
    const patternInput = useTranslation();
    const permissions = usePermissions();
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => {
        const tupledArg = init(props.SuccessCallback, props.OnClose, props.UserData, permissions, props.SenderId, props.AssignProps, props.PredefinedQuantities, props.ReceiverId);
        return whenOpen(props.IsOpen, tupledArg[0], tupledArg[1]);
    }, update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_2 = patternInput_1[0];
    return reactElement("div", createObj(singleton_1((elems = [createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: (matchValue = state_2.Receivers, (matchValue_1 = state_2.Consumables, (matchValue_2 = state_2.Sets, (matchValue_3 = state_2.Tools, (matchValue_4 = state_2.Storages, (matchValue_5 = state_2.AvailabilityResult, (matchValue.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_1.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_2.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_3.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_4.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_5.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : createElement(Content, {
            AvailabilityResults: matchValue_5.fields[0],
            Dispatch: patternInput_1[1],
            Dto: state_2.Dto,
            FormState: state_2.FormState,
            PlannedReturnDate: unwrap(state_2.PlannedReturnDate),
            Receivers: matchValue.fields[0],
            RemovedElements: state_2.RemovedElements,
            Storages: matchValue_4.fields[0],
            TableElements: state_2.TableElements,
            WithNotification: state_2.WithNotification,
            WithSignature: state_2.WithSignature,
        })))))))))))),
        Controls: empty(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: patternInput[0]("general.assign"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

